import { render, staticRenderFns } from "./ModalCurrencyConverter.vue?vue&type=template&id=3b5384de&scoped=true&"
import script from "./ModalCurrencyConverter.vue?vue&type=script&lang=js&"
export * from "./ModalCurrencyConverter.vue?vue&type=script&lang=js&"
import style0 from "./ModalCurrencyConverter.vue?vue&type=style&index=0&id=3b5384de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5384de",
  null
  
)

export default component.exports